import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContractStage } from '../shared.types';

@Component({
  selector: 'contract-stage',
  templateUrl: './contract-stage.component.html',
  styleUrls: ['./contract-stage.component.scss']
})
export class ContractStageComponent implements OnInit {

  constructor() { }

  @Input() stage                      = ContractStage.quote;
  ContractStage: typeof ContractStage = ContractStage;

  ngOnInit() { }

}
